export enum ActionDialog {
    CONFIRM = 'import',
    CANCEL = 'cancel',
}
